/**
 * 国家类型
 */
enum CountryType {
  /** 通用 */
  GP = -1,
  /** 美国 */
  US = 1,
  /** 日本 */
  JA = 81,
  /** 韩国 */
  KO = 82,
}

export default CountryType
